import { blobResponseHandler, downloadBlob } from '@/shared/helpers/api';
import { baseApi } from '@/warehouse/baseApi';
export const pickingApi = baseApi.enhanceEndpoints({ addTagTypes: ['GeneralSettings'] }).injectEndpoints({
    endpoints: (builder) => ({
        // Same backend endpoint (GeneralSettings) is used in Admin. Mb extract to shared if necessary?
        // TODO: Old frontend has progress bar while downloading
        downloadPrinterService: builder.query({
            queryFn: async (osPlatform, api, extraOptions, baseQuery) => downloadBlob({
                queryResult: await baseQuery({
                    method: 'GET',
                    cache: 'no-cache',
                    url: 'GeneralSettings/PrintingService',
                    params: { osPlatform },
                    responseHandler: blobResponseHandler,
                }),
                fileName: `setPrinter-${osPlatform}.zip`,
            }),
        }),
    }),
});
export const { useLazyDownloadPrinterServiceQuery } = pickingApi;
